/**
 * @fileoverview GET handler for the "/users/preference_center/select" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { usersPreferenceCenterSelect } from "./constants";
import type { UsersPreferenceCenterSelectResult } from "./types";

export const getUsersPreferenceCenterSelect = reactQueryFetcherAdapter(
  usersPreferenceCenterSelect,
  (signal: AbortSignal, query: string, limit: number): Promise<UsersPreferenceCenterSelectResult> => {
    return fetch("/users/preference_center/select", "GET", { query, limit }, { signal });
  }
);
